export default __webpack_public_path__ + "static/media/361.ad2d98aa.png";